import { SET_TOGGLE_STATE, SET_HIDE_SPONSOR } from '../../constants'

const intialState = {
  activeState: false,
}

export default function PlayerHeaderReducer(state = intialState, action) {
  switch (action.type) {
    case SET_TOGGLE_STATE: {
      return {
        ...state,
        activeState: action.activeState,
      }
    }
    case SET_HIDE_SPONSOR: {
      return {
        ...state,
        hideSponsor: action.hideSponsor,
      }
    }
    default: {
      return state
    }
  }
}
